<style lang="scss" scoped>
  @import "../../../scss/app";

  .page-content {
    padding-left: 300px;
    overflow: auto;
    height: 100%;
  }
</style>

<template>
  <div class="full-height">

    <myo-sidebar>

      <div class="p3 bg-light-blue">
        <div class="text-grey">Handlekurv</div>
        <div class=" center" v-if="state.is('loading')">
          <div class="md-spinner md-theme-default md-indeterminate"
               style="width: 20px; height: 20px;">
            <svg viewBox="25 25 50 50" class="md-spinner-draw">
              <circle cx="50" cy="50" r="20" stroke-width="3.5" class="md-spinner-path"></circle>
            </svg>
          </div>
        </div>
        <div class="mt1" v-else-if="$root.$data.cart">
          <div v-if="$root.$data.cart.items.length === 0">
            <div class="fz18 text-blue">Handlekurven er tom...</div>
          </div>
          <div class="clearfix mt1 bold" v-else>
            <div class="col col-6 fz18 text-blue">kr {{ toLocale($root.$data.cart.gross_total / 100) }},-</div>
            <div class="col col-6 text-dark-grey right-align">
              {{ $root.$data.cart.items.length }}
              <span v-if="$root.$data.cart.items.length > 1">varer</span>
              <span v-else>vare</span>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="text-grey pt3 pl3 pr3 pb1">Mine sider</div>
        <router-link to="/app/shop/my-orders" class="myo-list-item">Mine ordre</router-link>
        <!-- <router-link to="/app/shop/my-carts" class="myo-list-item">Lagrede hadlekurver</router-link> -->
        <div class="text-grey pt3 pl3 pr3 pb1">Handle</div>
        <router-link to="/app/shop/category/all" class="myo-list-item">Alle produkter</router-link>
        <router-link to="/app/shop/category/expo-products" class="myo-list-item">Expo-produkter</router-link>
        <router-link to="/app/shop/category/digital-print" class="myo-list-item">Digitale trykksaker</router-link>
      </div>

      <div class="px3 py2 italic text-grey">Flere produkter kommer snart...</div>


    </myo-sidebar>

    <div class="page-content">
      <div class="p3">
        <router-view></router-view>
      </div>
    </div>

  </div>
</template>

<script>
  import apiCart from '@/js/api/cart';
  import State from '@/js/helpers/state';
  import hasPrices from '@/js/mixins/hasPrices';

  export default {
    mixins: [hasPrices],

    data() {
      return {
        state: new State(),
        cart: null,
      };
    },

    mounted() {
      this.state.start('loading');
      apiCart.get().then(this.onCartSuccess);
    },

    methods: {
      onCartSuccess(cart) {
        apiCart.show(cart.id).then(this.onFetchSuccess);
      },

      onFetchSuccess(response) {
        this.$root.$data.cart = response.data.data;
        this.state.stop('loading');
      },
    },
  };
</script>



// WEBPACK FOOTER //
// Shop.vue?2defb199